module.exports = __webpack_public_path__ + "static/media/copy.fa47f56f.svg";